function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Line-Items",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Line-Item-View:-Return:-Automation-Banner",
  transform: "translate(-784.000000, -78.000000)",
  fill: "#0a131b",
  stroke: "#0a131b"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(780.000000, 74.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.9558672,15.152 C23.9558672,10.2974273 20.0062681,6.34782827 15.1516954,6.34782827 C10.2971227,6.34782827 6.34752369,10.2974273 6.34752369,15.152 C6.34752369,20.0065727 10.2971227,23.9561717 15.1516954,23.9561717 C20.0062681,23.9561717 23.9558672,20.0065727 23.9558672,15.152 L23.9558672,15.152 Z M25.304,15.152 C25.304,17.8636087 24.2479563,20.4131827 22.3304933,22.3304933 C20.4129162,24.2480705 17.8638753,25.304 15.152,25.304 C12.4403913,25.304 9.89081733,24.2479563 7.97350668,22.3304933 C6.05592953,20.4129162 5,17.8634945 5,15.152 C5,12.4405055 6.05604374,9.89081733 7.97350668,7.97350668 C9.89108384,6.05592953 12.4405055,5 15.152,5 C17.8638753,5 20.4131827,6.05604374 22.3304933,7.97350668 C24.2480705,9.89108384 25.304,12.4405055 25.304,15.152 L25.304,15.152 Z M15.8259522,9.57672256 L15.8259522,15.152 C15.8259522,15.291953 15.7823597,15.4283273 15.7013422,15.542239 L13.1927339,19.0734257 C13.0612329,19.2582657 12.8534735,19.357177 12.6427825,19.357177 C12.5077408,19.357177 12.3715188,19.3167444 12.2530004,19.232567 C11.9494516,19.0169267 11.878371,18.596192 12.0940113,18.2926432 L14.4781239,14.9367785 L14.4779716,9.57660834 C14.4779716,9.20433941 14.7797311,8.90261806 15.1519619,8.90261806 C15.5241928,8.90261806 15.8259522,9.20422519 15.8259522,9.57660834 L15.8259522,9.57672256 Z",
  id: "Fill-1"
}))));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.7d39fd15.svg";
export { ForwardRef as ReactComponent };